import { LocalizedString } from "survey-engine/data_types";

export const isLocalizedString = (value: LocalizedString | any): value is LocalizedString => {
    if(typeof(value) !== 'object') {
        return false;
    }
    const v = (value as LocalizedString);
    return Array.isArray(v.parts);
}
  
